import {BifrostBackendApi} from "../../gateways/BifrostBackendApi";

const IdpManagementProvider = {
	async deleteUserFromIdp(tenantId, token, confirmation) {
		const idpManagementQueryParams = {
			tenantId,
			...(confirmation ? { confirmation: 1} : {})
		};
		return BifrostBackendApi.delete(`/auth0-management/remove`, {
			params: idpManagementQueryParams,
			headers: {
				Authorizationidp: token
			}
		});
	}
};

export default Object.freeze(IdpManagementProvider);
